import RestAPI from "../../../../util/RestAPI";
import { Student } from "../../types";

export async function getStudent(classId: string, studentId: string) {
  try {
    const student: Student = (await RestAPI.get(
      `/students/object/${classId}/${studentId}`
    ).then((res) => res.json())) as any as Student;
    return student;
  } catch (err) {

    return;
  }
}
